import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

let discoverSwiper: Swiper | null = null;

export function initDiscoverMobileHomeCarousel(): void {
  if (window.innerWidth < 992 && !discoverSwiper) {
    const options: SwiperOptions = {
      modules: [Pagination],
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 20,
      loop: false,
      slideToClickedSlide: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    };

    discoverSwiper = new Swiper('#js-preview-tiles', options);
  }
}

export function destroyDiscoverMobileHomeCarousel(): void {
  if (discoverSwiper) {
    discoverSwiper.destroy(true, true);
    discoverSwiper = null;
  }
}
